import React, { useContext } from "react";
import "./PageNine.scss";
import { BuildingsContext } from "../../../bContext";

function PageNine() {
  const { switchToEnglish} = useContext(
    BuildingsContext
  );
  return (
    <>
      <div className="pageNine">
       
        {/* <div className="menu-pg4"></div> */}

        <div>
          <div className="speech-bubble5">
            {switchToEnglish === false ? 
            <p className="first">
              Kiedy klikniemy w wybrany obiekt, wyświetli nam się nowe okno, a w nim szczegółowy opis.
            </p>
            :
            <p className="first">
            When you click on a selected object, a new window will appear, with a detailed description in it
          </p> 
            }
          </div>
          {/* <div className="speech-bubble6">
            <p className="first">
              ...natomiast jego nazwa wyświetli się w tym okienku.
            </p>
            <div className="inner-triangle-right6"></div>
          </div> */}
          {/* <div className="menu-pg5"></div>  */}

          <div className="modal-header-ins"></div>
          <div className="modalbtn"></div>
          <div className="defaultbtn"></div>
        </div>
      </div>
    </>
  );
}

export default PageNine;
